document.body.addEventListener('touchstart', iosAudioContextResume, false);
document.body.addEventListener('touchend', iosAudioContextResume, false);

function iosAudioContextResume() {
  if (window.audioctx) {
    // alert(window.audioctx.state);
    window.audioctx.resume();

    setTimeout(() => {
      // alert(window.audioctx.state);
      if (window.audioctx.state === 'running') {
        // alert("resumed");
        document.body.removeEventListener('touchstart', iosAudioContextResume, false);
        document.body.removeEventListener('touchend', iosAudioContextResume, false);
      }
    }, 100);
  }
}


// WEBPACK FOOTER //
// ./src/components/iosAudioContext.js